import { Controller } from "@hotwired/stimulus"

// Hover preview for the star picker. The actual submit is a plain form button,
// so rating works with JavaScript disabled.
export default class extends Controller {
  static targets = ["star"]
  static values = { current: Number }

  preview(event) {
    this.paint(Number(event.currentTarget.dataset.score))
  }

  reset() {
    this.paint(this.currentValue)
  }

  paint(score) {
    this.starTargets.forEach((star) => {
      const filled = Number(star.dataset.score) <= score
      star.classList.toggle("text-ink", filled)
      star.classList.toggle("text-line-strong", !filled)
    })
  }
}
